<template>
    <div>
        <div class="formSubmit">
            <vForm class="clearfix" v-model="formData" ref="dataForm">
                <vCol span="24">
                    <vFormItem
                        label="请选择索赔类型"
                        class="width-100per"
                        prop="reimbursementType"
                        :rules="required"
                        labelWidth="120"
                    >
                        <vSelect
                            v-model="formData.reimbursementType"
                            filterable
                            clearable
                            style="width: 250px"
                        >
                            <vOption
                                v-for="item in reimbursementTypeImportList"
                                :key="item.key"
                                :value="item.value"
                                >{{ item.label }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="24">
                    <vFormItem
                        label="管理方"
                        class="width-100per"
                        prop="hostOrgId"
                        :rules="required"
                        labelWidth="120"
                    >
                        <vSelect
                            v-model="formData.hostOrgId"
                            filterable
                            clearable
                            style="width: 250px"
                        >
                            <vOption
                                v-for="item in getBeforeOrgList"
                                :key="item.key"
                                :value="item.value"
                                >{{ item.label }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <div style="margin: 10px">
                    <compMutiUpload
                        v-bind="getFileProps"
                        @on-cancel="close"
                        @on-success="success"
                    />
                </div>
            </vForm>
        </div>
        <vLoading loading size="large" transfer v-if="loading"></vLoading>
    </div>
</template>

<script>
import { HttpGetBeforeOrgList } from "@/service/reimbursement";
import mixin from "./mixin";
import { mapGetters } from "vuex";
export default {
    mixins: [mixin],
    data() {
        return {
            loading: false,
            formData: {},
            required: [
                {
                    required: true,
                    message: "该信息不能为空,请填写",
                },
            ],
        };
    },
    created() {
        this.$set(this.formData, "reimbursementType", 9);
        HttpGetBeforeOrgList({}).then((res) => {
            if (res.data.length === 1) {
                this.$set(this.formData, "hostOrgId", res.data[0].id);
            }
        });
    },
    computed: {
        ...mapGetters("dictionary", ["getBeforeOrgList"]),
        getFileProps() {
            return {
                beforeUpload: (res) => {
                    if (!this.formData.reimbursementType) {
                        this.$VMessage.warning("请先选择索赔类型");
                        return false;
                    }
                    if (!this.formData.hostOrgId) {
                        this.$VMessage.warning("请先选择管理方");
                        return false;
                    }
                    return res;
                },
                action:
                    process.env.VUE_APP_APIURL_FBB +
                    "/api/v2/reimbursement/Reimbursement/importReim",
                name: "multipartFile",
                multiple: false,
                formatter: (res) => {
                    return this.$VMessage.warning("导入成功");
                },
                data: {
                    type: this.formData.reimbursementType,
                    hostOrgId: this.formData.hostOrgId,
                    contextId: global.SYSID,
                },
                download: () => {
                    if (this.formData.reimbursementType === 9) {
                        this.handleWebfs(
                            "/static/template/reimbursement_bill_inv.xlsx",
                            {},
                            {
                                executor: "download",
                                type: "url",
                            }
                        );
                    } else if (this.formData.reimbursementType === 10) {
                        this.handleWebfs(
                            "/static/template/reimbursement_bill_ship.xlsx",
                            {},
                            {
                                executor: "download",
                                type: "url",
                            }
                        );
                    } else if (this.formData.reimbursementType === 33) {
                        this.handleWebfs(
                            "/static/template/reimbursement_batchbill.xlsx",
                            {},
                            {
                                executor: "download",
                                type: "url",
                            }
                        );
                    }
                },
            };
        },
    },
    methods: {
        close() {
            this.$emit("on-close");
        },
        success() {
            this.close();
            this.$emit("on-update");
        },
    },
};
</script>
